export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/formular-regular-e86322695ea3b282488575160fbae2ae.woff2";